import { render, staticRenderFns } from "./NewTermDialog.vue?vue&type=template&id=7fc13997&scoped=true&"
import script from "./NewTermDialog.vue?vue&type=script&lang=ts&"
export * from "./NewTermDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewTermDialog.vue?vue&type=style&index=0&id=7fc13997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc13997",
  null
  
)

export default component.exports